import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable()
export class PlatformGuardService  {

    constructor(
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const platform = route.queryParams['p'];
        if (platform === 'o' || !platform) {
            return true;
        } else {
            this.router.navigate(['/']);

            return false;
        }
    }
}
